import React from 'react'
import { Route, Switch } from 'react-router-dom'

import { NotifierContainer } from '@softwaredev_cegeka/stix-notifier'

import { routeConfig } from './config'
import { ContentRoute } from 'src/routes/ContentRoute'
import { Header, ErrorBoundary } from 'src/components'
import { NotFound, InternalServerError } from './Error'

class Main extends React.Component {
    render() {
        return (
            <>
                <NotifierContainer />
                <Header />
                <NotifierContainer />
                <Switch>
                    {/*this needs to be outside because we redirect to it from the ErrorBoundary*/}
                    <Route
                        exact
                        path={'/internal-error'}
                        component={InternalServerError}
                    />
                    <Route>
                        <ErrorBoundary>
                            <Switch>
                                {routeConfig.map((route, index) => {
                                    const {
                                        path,
                                        component,
                                        title,
                                        name,
                                        breadcrumbs,
                                        ...rest
                                    } = route

                                    if (route.permissions instanceof Function) {
                                        if (
                                            !route.permissions(
                                                this.props.userData
                                            )
                                        ) {
                                            return null
                                        }
                                    }
                                    return (
                                        <ContentRoute
                                            key={index}
                                            match={this.props.match}
                                            path={path}
                                            component={component}
                                            title={title}
                                            name={name}
                                            breadcrumbs={breadcrumbs}
                                            {...rest}
                                        />
                                    )
                                })}
                                <Route component={NotFound} />
                            </Switch>
                        </ErrorBoundary>
                    </Route>
                </Switch>
            </>
        )
    }
}

export default Main
